<template>
  <toolbar title="Einstellungen" />
  <div class="w-full relative text-center">
    <div class="w-full border-b border-b-gray-200 py-2 pl-2 text-left" onclick="window.location='/impressum'">
      <span class="align-middle font-bold">Impressum</span>
      <i
        class="
          fa fa-chevron-right
          align-middle
          float-right
          mt-1
          mr-5
          text-gray-500
        "
      />
    </div>
    <span class="font-bold mt-10 inline-block">Version: 2.1.27</span><br>
    <button @click="logout" :disabled="statsLoading || !statsLoaded" class="border-red-500 border-2 rounded-lg text-red-500  text-lg font-bold px-7 mt-2">{{ stats.impersonating ? "Ausloggen (Admin)" : "Ausloggen" }}</button>
  </div>
</template>
<script>
import Toolbar from "@/components/Toolbar.vue";
import { useCookies } from "vue3-cookies";
import CASP from "../../CASP";
export default {
  setup() {
    const { cookies } = useCookies();
    return { cookies };
  },
  components: { Toolbar },
  data() {
    return {
      stats: {},
      statsLoading: true,
      statsLoaded: false,
    };
  },
  methods: {
    getStats() {
      this.statsLoading = true;
      CASP.getStats((status, response) => {
        this.statsLoading = false;
        if (status === 200) {
          this.stats = response;
          this.statsLoaded = true;
        } else {
          this.statsLoaded = false;
        }
      });
    },
    logout() {
      if (!this.statsLoaded) return;
      if (this.stats.impersonating) {
        const token = this.cookies.get("caspauth") || this.cookies.get("authtoken");
        CASP.stopImpersonation(token, (status) => {
          if (status === 200) {
            if (localStorage) localStorage.removeItem("stats");
            window.location = "/admin/employees";
          } else {
            alert("Die Admin-Identität konnte nicht wiederhergestellt werden.");
          }
        });
        return;
      }
      CASP.logoutWeb((status) => {
        if (status === 200) {
          this.cookies.remove("caspauth");
          this.cookies.remove("authtoken");
          if (localStorage) localStorage.removeItem("stats");
          window.location = "/forbidden";
        } else if (status === 409) {
          this.getStats();
          alert("Die Sitzung wird als Admin verwendet. Bitte erneut versuchen.");
        } else {
          alert("Das Ausloggen ist fehlgeschlagen.");
        }
      });
    },
  },
  created: function () {
    document.getElementById("mainspinner").style.display = "none";
    if (this.cookies.get("caspauth") || this.cookies.get("authtoken")) {
      this.token = this.cookies.get("caspauth") || this.cookies.get("authtoken");
      this.getStats();
    } else {
      window.location = "/forbidden";
    }
  },
};
</script>
